import { Navigate, Outlet } from 'react-router-dom';

import { useWizardNavigation } from '../hooks/useWizard';
import { useWizardSteps } from '../providers/WizardStepsContext';

const RouteGuardLayout = () => {
	const { currentStep } = useWizardNavigation();
	const { stepState } = useWizardSteps();

	const isStepValid =
		currentStep?.key === 'general'
			? true
			: (stepState[currentStep?.key ?? 'general']?.isValid ?? false);

	if (!isStepValid) {
		return <Navigate to={`general`} replace />;
	}

	return <Outlet />;
};

export default RouteGuardLayout;
